import CheckInButton from "./Buttons/CheckInButton";
import RegisterButton from "./Buttons/RegisterButton";
import SurveyButton from "./Buttons/SurveyButton";
import FavoriteButton from "./Buttons/FavoriteButton";
import {useAuth} from "../../../services/use-auth";

export default function EventAction(
    {
        id,
        registrationRequired,
        isStarted,
        isFinished,
        isUserCheckedIn,
        isRegistrationAvailable,
        isUserRegistered,
        isSurveyAvailable,
        isInFavorite,
        eventDataUpdate,
    }
) {
    const auth = useAuth();
    const showCheckInButton = !isFinished;
    const showSurveyButton = isFinished && isSurveyAvailable &&
        (registrationRequired ? isUserRegistered && isUserCheckedIn : isUserRegistered || isUserCheckedIn)

    return (
        <>
            { (!!auth.user && showCheckInButton) &&
                <CheckInButton
                    id={id}
                    isStarted={isStarted}
                    isUserCheckedIn={isUserCheckedIn}
                    registrationRequired={registrationRequired}
                    isUserRegistered={isUserRegistered}
                    eventDataUpdate={eventDataUpdate}
                />
            }
            { isRegistrationAvailable &&
                <RegisterButton
                    isUserRegistered={isUserRegistered}
                    isStarted={isStarted}
                    id={id}
                />
            }
            { showSurveyButton &&
                <SurveyButton
                    id={id}
                />
            }
            {
                !!auth.user && <FavoriteButton
                    id={id}
                    isInFavorite={isInFavorite}
                    eventDataUpdate={eventDataUpdate}
                />
            }

        </>
    )
}
